import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getAccountMapping } from 'services/api/AdebifyApi';
import types from './types';
import actions from './actions';
import { selectAdebifyChecked } from './selectors';

function* checkAdebifyFeature() {
  // Only check once per session — if already checked, skip
  const isChecked = yield select(selectAdebifyChecked);
  if (isChecked) {
    return;
  }

  yield put(actions.setAdebifyLoading(true));

  try {
    yield call(getAccountMapping);
    // 200 response means adebify is enabled for this account
    yield put(actions.setAdebifyEnabled(true));
  } catch (error) {
    if (error?.response?.status === 403) {
      // 403 means adebify is not enabled for this account
      yield put(actions.setAdebifyEnabled(false));
    } else {
      // Other errors (network, 500, etc.) — treat as not enabled
      yield put(actions.setAdebifyEnabled(false));
    }
  }
}

export default function* adebifyOperations() {
  yield takeLatest(types.CHECK_ADEBIFY_FEATURE, checkAdebifyFeature);
}
